import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "model-item relative mb-2 pt-6 pb-8 px-8 border border-line rounded-md bg-white" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-xl font-semibold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-building text-2xl" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rs-trash text-2xl" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "flex w-96" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "flex fi fi-tr-cubes text-7xl text-placeholder" }, null, -1)
const _hoisted_14 = { class: "py-1" }
const _hoisted_15 = { class: "text-desc text-md" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "사이즈:", -1)
const _hoisted_17 = { class: "ml-1" }
const _hoisted_18 = { class: "mt-3 text-desc text-md" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "부피:", -1)
const _hoisted_20 = { class: "ml-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_22 = { class: "mt-4" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-cubes" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 mr-1" }, "자동분석 결과: ", -1)
const _hoisted_26 = { class: "" }
const _hoisted_27 = {
  key: 0,
  class: "m-auto mt-2 cs-caption"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-exclamation mr-1" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"1.3"} }, [
    /*#__PURE__*/_createTextVNode(" 위 항목을 클릭하면 상세 내용을"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("확인할 수 있습니다. ")
  ])
], -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "ml-6 mr-6 border-l border-line" }, null, -1)
const _hoisted_32 = { class: "w-60" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-desc" }, "공정·재료", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 mb-3 border-b border-line" }, null, -1)
const _hoisted_35 = { class: "flex items-center mt-5" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mr-5",
  for: "pating"
}, "도색", -1)
const _hoisted_37 = ["checked"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "ml-6 mr-6 border-l border-line" }, null, -1)
const _hoisted_39 = { class: "w-24" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-desc" }, "수량", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 mb-3 border-b border-line" }, null, -1)
const _hoisted_42 = {
  class: "cs-form flex w-full",
  "data-height": "s"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "ml-6 mr-6 border-l border-line" }, null, -1)
const _hoisted_44 = { class: "flex items-center justify-end" }
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = { class: "flex items-center" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "mr-3 text-1desc" }, "단가", -1)
const _hoisted_48 = {
  class: "w-28 inline-block cs-form",
  "data-height": "xs"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "원", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-3 border-b border-line" }, null, -1)
const _hoisted_51 = { class: "flex items-center justify-between" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "mr-3 text-1desc" }, "비용", -1)
const _hoisted_53 = { class: "text-4xl font-bold" }
const _hoisted_54 = {
  key: 0,
  class: "items-center justify-center bounding-loader rounded-md"
}
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"loader-boxs\"><div class=\"scene\"><div class=\"plane\"><div class=\"cube cube--0\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--0\"></div><div class=\"cube cube--1\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--1\"></div><div class=\"cube cube--2\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--2\"></div><div class=\"cube cube--3\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--3\"></div><div class=\"cube cube--4\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--4\"></div><div class=\"cube cube--5\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--5\"></div><div class=\"cube cube--6\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--6\"></div><div class=\"cube cube--7\"><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div><div class=\"cube__side\"></div></div><div class=\"shadow shadow--7\"></div></div></div></div><div class=\"bounding-loader-text text-center\"><p class=\"font-semibold text-lg\">업로드 및 분석 중 입니다, 잠시만 기다려주세요.</p></div>", 2)
const _hoisted_57 = [
  _hoisted_55
]


import {defineComponent, onMounted, ref, computed, watch, defineEmits} from "vue";
import {storeToRefs} from "pinia";
import axios from "axios";
import {CommonStore} from "../../store/common-store";
import {OptionsStore} from "../../store/options-store";
import {EstimateStore} from "../../store/estimate-store";
import {ModelStore} from "../../store/model-store";
import {Model3D, GModalData, Process, DropItem} from "../../js/interface";
import {AnalysisStatus, AnalysisStatusKo, Modals} from "../../js/types";
import {binaryToArrayBuffer, reqUploadModel} from "../../js/upload";
import {numberToComma, removeComma} from "../../js/utils";

import Dropdown, {DropdownItem} from "../../components/Dropdown.vue";
import Thumbnail from "../../components/Thumbnail.vue";

const __default__ = defineComponent({
  name: "AdminModel",
  components: {
    Thumbnail,
    Dropdown,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  model: {
    type: Object as () => Model3D,
    required: true,
  },
},
  emits: ["onShowCompanys"],
  setup(__props, { emit }) {

const props = __props;

const {modalResult} = storeToRefs(CommonStore());
const optionsStore = OptionsStore();
const {processes, materials} = storeToRefs(optionsStore);
const estimateStore = EstimateStore();
const modelStore = ModelStore();




const fileDownload = ref();

const currentPercent = ref(0);
const modelCount = ref(1);
const modelCost = ref("0");
const dropProcessTitle = ref("");
const dropMaterialTitle = ref("");
const isPaint = ref(false);

watch(modalResult, (newV, oldV) => {
  if (props.model.id !== newV.result.modelId) {
    return;
  }

  switch (newV.modalName) {
    case Modals.ModelTrash:
      modelStore.removeModel(props.model.id);
      break;
  }
});

watch(props.model, (newV, oldV) => {
  modelCost.value = numberToComma(newV.modelCost);
});

onMounted(async () => {
  modelCost.value = numberToComma(props.model.modelCost);

  if (!props.model.isUploaded) {
    const arrayBuffer = await binaryToArrayBuffer(props.model.file);
    if (arrayBuffer) {
      reqUploadModel(props.model, arrayBuffer, currentPercent);
    }
  } else {
    modelCount.value = props.model.modelCount;
    const processName = optionsStore.getProcessName(props.model.modelProcessId);
    if (processName) {
      dropProcessTitle.value = processName;
    }
  }

  let isSameMaterial = false;
  for (let m = 0; m < materials.value.length; m++) {
    const mate = materials.value[m];
    if (props.model.modelMaterialId === mate.id) {
      isSameMaterial = true;
      dropMaterialTitle.value = mate.name;
      break;
    }
  }

  if (!isSameMaterial) {
    modelStore.setModelMaterial(props.model.id, materials.value[0].id);
    dropMaterialTitle.value = materials.value[0].name;
    modelStore.reqActiveModel(props.model);
  }

  return;
});

/**********************************************
 * Computed
 *********************************************/
const classAnalysis = computed(() => {
  switch (props.model.modelAnalysis) {
    case AnalysisStatus.Fail:
      return "cs-btn-disabled";
    case AnalysisStatus.Warn:
      return "cs-btn-warn";
    case AnalysisStatus.Caution:
      return "cs-btn-caution";
    default:
      return "cs-btn-success";
  }
});
const totalAnalysis = computed(() => {
  if (AnalysisStatus.Processing === props.model.modelAnalysis) {
    return AnalysisStatusKo.Processing;
  }

  switch (props.model.modelAnalysis) {
    case AnalysisStatus.Fail:
      return AnalysisStatusKo.Fail;
    case AnalysisStatus.Warn:
      return AnalysisStatusKo.Warn;
    case AnalysisStatus.Caution:
      return AnalysisStatusKo.Caution;
    default:
      return AnalysisStatusKo.Pass;
  }
});
const dropProcess = computed(() => {
  const items: DropItem[] = [];

  processes.value.forEach((val) => {
    items.push({
      title: val.name,
      data: val,
    });
  });

  return items;
});
const dropMaterial = computed(() => {
  const items: DropItem[] = [];

  materials.value.forEach((val) => {
    if (props.model.modelProcessId === val.processId) {
      items.push({
        title: val.name,
        data: val,
      });
    }
  });

  return items;
});

/**********************************************
 * Event
 *********************************************/
const onDownload = () => {
  axios
    .post(`/models/${props.model.id}`, {
      key: props.model.modelKey,
      name: props.model.name,
    })
    .then((r) => {
      fileDownload.value.href = r.data.result.signedUrl;
      fileDownload.value.setAttribute("download", props.model.name);
      fileDownload.value.click();
    });
};
const onTrash = () => {
  const data: GModalData = {
    modalName: Modals.ModelTrash,
    isShowCancel: false,
    title: "확인",
    content: "파일을 삭제하시겠습니까?",
    result: {
      modelId: props.model.id,
    },
  };
  CommonStore().showGlobalModal(data);
};
const onShowCompanys = () => {
  emit("onShowCompanys", props.model);
};
const onChangePainting = () => {
  modelStore.setModelPaint(props.model.id, !props.model.modelPaint);
  return;
};
const onModelCount = () => {
  if (!modelCount.value) {
    modelCount.value = 1;
  }
  if (30 < modelCount.value) {
    modelCount.value = 30;
  }
  modelStore.setModelCount(props.model.id, modelCount.value);
};
const onBlurModelCount = () => {
  if (!modelCount.value) {
    modelCount.value = 1;
  }
  if (30 < modelCount.value) {
    modelCount.value = 30;
  }
  modelStore.setModelCount(props.model.id, modelCount.value);
};
const onDropProcess = async (item: any) => {
  modelStore.setModelProcess(props.model.id, item.data.id);
  dropProcessTitle.value = item.name;

  for (let m = 0; m < materials.value.length; m++) {
    const mate = materials.value[m];
    if (props.model.modelProcessId === mate.processId) {
      dropMaterialTitle.value = mate.name;
      modelStore.setModelMaterial(props.model.id, mate.id);
      await modelStore.reqActiveModel(props.model);
      break;
    }
  }
};
const onDropMaterial = (item: any) => {
  dropMaterialTitle.value = item.data.name;
  modelStore.setModelMaterial(props.model.id, item.data.id);
  modelStore.reqActiveModel(props.model);
};
const onShowViewer = () => {
  modelStore.setCurrentModel(props.model);
};
const costNumberToComma = (cost: any) => {
  if ("number" === typeof cost) {
    return;
  }

  if (cost.length) {
    modelCost.value = cost.replace(/[^0-9,]/g, "");
    modelCost.value = removeComma(modelCost.value);
    let num = Number.parseInt(modelCost.value);
    if (16000000 < num) {
      num = 16000000;
    }
    modelCost.value = numberToComma(num);
  } else {
    modelCost.value = "0";
  }

  modelStore.setModelCost(props.model.id, Number.parseInt(removeComma(modelCost.value)));
  estimateStore.calculateTotalCost();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("a", {
      ref_key: "fileDownload",
      ref: fileDownload
    }, null, 512), [
      [_vShow, false]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(__props.model.name), 1)
      ]),
      _createElementVNode("div", { class: "flex" }, [
        _createElementVNode("button", { class: "mr-3 cs-icon-btn clear" }, [
          _createElementVNode("i", {
            class: "fi fi-rr-cloud-download-alt text-2xl",
            onClick: onDownload
          })
        ]),
        _createElementVNode("button", {
          class: "mr-3 cs-icon-btn clear",
          onClick: onShowCompanys
        }, _hoisted_6),
        _createElementVNode("button", {
          class: "cs-icon-btn clear",
          onClick: onTrash
        }, _hoisted_8)
      ])
    ]),
    (__props.model)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(Thumbnail, {
                  size: '',
                  url: __props.model.thumbnailUrl,
                  defaultIcon: false,
                  customCss: 'mr-6 w-24 h-24 bg-layout md:w-28 md:h-28',
                  borderWidth: 1,
                  borderColor: '#c0c2c4',
                  round: '5px'
                }, {
                  "default-icon": _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["url"]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, _toDisplayString(parseFloat(__props.model.modelSizeX.toFixed(2))) + " x " + _toDisplayString(parseFloat(__props.model.modelSizeY.toFixed(2))) + " x " + _toDisplayString(parseFloat(__props.model.modelSizeZ.toFixed(2))) + _toDisplayString(__props.model.modelUnit), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", _hoisted_20, [
                        _createTextVNode(_toDisplayString(_unref(numberToComma)(__props.model.modelVolume)) + "㎜", 1),
                        _hoisted_21
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["cs-btn cs-pd-btn-xs", [classAnalysis.value]]),
                      onClick: onShowViewer
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _hoisted_25,
                        _createElementVNode("span", _hoisted_26, _toDisplayString(totalAnalysis.value), 1)
                      ])
                    ], 2),
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _hoisted_34,
                _createVNode(Dropdown, {
                  title: dropProcessTitle.value,
                  items: dropProcess.value,
                  onOnClick: onDropProcess
                }, null, 8, ["title", "items"]),
                _createVNode(Dropdown, {
                  class: "mt-3",
                  title: dropMaterialTitle.value,
                  items: dropMaterial.value,
                  onOnClick: onDropMaterial
                }, null, 8, ["title", "items"]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("input", {
                    class: "form-check-input",
                    id: "pating",
                    type: "checkbox",
                    checked: __props.model.modelPaint,
                    onChange: onChangePainting
                  }, null, 40, _hoisted_37)
                ])
              ]),
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    class: "",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelCount).value = $event)),
                    onInput: onModelCount,
                    onBlur: onBlurModelCount,
                    min: "1",
                    max: "30",
                    oninput: "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');",
                    type: "number"
                  }, null, 544), [
                    [_vModelText, modelCount.value]
                  ])
                ])
              ]),
              _hoisted_43
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("div", _hoisted_48, [
                    _withDirectives(_createElementVNode("input", {
                      class: "text-right",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelCost).value = $event)),
                      type: "text",
                      placeholder: "",
                      onKeyup: _cache[2] || (_cache[2] = ($event: any) => (costNumberToComma(modelCost.value))),
                      onBlur: _cache[3] || (_cache[3] = ($event: any) => (costNumberToComma(modelCost.value)))
                    }, null, 544), [
                      [_vModelText, modelCost.value]
                    ])
                  ]),
                  _hoisted_49
                ]),
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("span", _hoisted_53, _toDisplayString(_unref(numberToComma)(__props.model.modelCost * modelCount.value)) + "원", 1)
                ])
              ])
            ])
          ]),
          (__props.model.analysis && !__props.model.analysis.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_57))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})